/**
 * Shared vocabulary of the learning domain. Content packs, the game engine,
 * persistence and the UI all speak in these identifiers.
 */

/** Interface languages. Arabic is the default and the reference translation. */
export const LOCALES = ['ar', 'fr', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

/** Languages an exercise can be taught in (may differ from the interface language). */
export const TEACHING_LANGUAGES = ['ar', 'fr', 'en'] as const;
export type TeachingLanguage = (typeof TEACHING_LANGUAGES)[number];

/** التحضيري then السنة الأولى … السادسة ابتدائي. */
export const LEVEL_IDS = ['prep', 'y1', 'y2', 'y3', 'y4', 'y5', 'y6'] as const;
export type LevelId = (typeof LEVEL_IDS)[number];

export const SCHOOL_TYPES = ['public', 'private'] as const;
export type SchoolType = (typeof SCHOOL_TYPES)[number];

export const GAME_IDS = [
  'quick-quiz',
  'find-correct',
  'missing-number',
  'word-builder',
  'letter-sound',
  'sentence-builder',
  'memory',
  'categorize',
  'true-false',
  'daily-mission',
] as const;
export type GameId = (typeof GAME_IDS)[number];

export const EXERCISE_KINDS = [
  'choice',
  'input',
  'trueFalse',
  'order',
  'match',
  'memory',
  'categorize',
] as const;
export type ExerciseKind = (typeof EXERCISE_KINDS)[number];

/**
 * Error categories recorded with incorrect answers. They drive revision and
 * parent summaries; they describe an answer, never the child.
 */
export const MISTAKE_TYPES = [
  // Mathematics
  'off-by-one',
  'wrong-operation',
  'place-value',
  'regrouping',
  'smaller-from-larger',
  'table-slip',
  'counting',
  // Languages
  'similar-letter-shape',
  'similar-sound',
  'letter-position',
  'harakat',
  'letter-order',
  'word-order',
  'spelling',
  'article',
  'agreement',
  'conjugation',
  'vocabulary',
  'comprehension',
  'grammar-role',
  // Science and general
  'classification',
  'misconception',
  'unknown',
] as const;
export type MistakeType = (typeof MISTAKE_TYPES)[number];

export const MASTERY_STATUSES = [
  'notStarted',
  'learning',
  'needsPractice',
  'progressing',
  'provisionalMastery',
] as const;
export type MasteryStatus = (typeof MASTERY_STATUSES)[number];

export const PUBLICATION_STATUSES = [
  'draft',
  'reviewed',
  'approved',
  'published',
  'archived',
] as const;
export type PublicationStatus = (typeof PUBLICATION_STATUSES)[number];

/** How far a piece of content has been checked against official Tunisian sources. */
export const VERIFICATION_STATUSES = [
  'unverified-sample',
  'needs-review',
  'educator-reviewed',
  'officially-aligned',
] as const;
export type VerificationStatus = (typeof VERIFICATION_STATUSES)[number];
